import { useEffect, useState } from "react";
import "./App.css";
import Login from "./components/Login";
import Dashboard from "./layouts/Dashboard";
import { getAuth } from "firebase/auth";

function App() {

  const [token, setToken] = useState<any>(null);
  
  useEffect(() => {
    // Escuchar cambios en el estado de autenticación
    const auth = getAuth();
    auth.onAuthStateChanged((user) => {
      if (user) {
        user.getIdToken().then((token) => {
          setToken(token);
        });
      } else {
        setToken(null);
      }
    });
  })
  

  return (
    <>
      {token ? (
        <div className="fondoPantallaGeneralImagen">
          <Dashboard />
        </div>
      ) : (
        <Login />
      )}
    </>
  );
}

export default App;